// extracted by mini-css-extract-plugin
var _1 = "ControlBarAddOrSharePopOver-module__animateUploadProgressBarWidth--rYs7R";
var _2 = "ControlBarAddOrSharePopOver-module__animatedBackground--mB_wW";
var _3 = "ControlBarAddOrSharePopOver-module__arrow--s6AIs";
var _4 = "ControlBarAddOrSharePopOver-module__container--oF6Ph";
var _5 = "ControlBarAddOrSharePopOver-module__input--t6ApN";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "arrow", _4 as "container", _5 as "input" }
